import { permissionConstants } from '../constants';
import { alertActions } from 'actions';
import { permissionService } from 'services';
import { gisRoutes } from '../routes/routes';
import { global } from 'config';
import { history } from 'helpers';

export const permissionActions = {
  get,
  getAll,
  add,
  update,
  remove
};

function get(permission_id) {
  return dispatch => {
    dispatch(request());

    permissionService.get(permission_id)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: permissionConstants.GET_PERMISSION_REQUEST } }
  function success(data) { return { type: permissionConstants.GET_PERMISSION_SUCCESS, data } }
  function failure(error) { return { type: permissionConstants.GET_PERMISSION_FAILURE, error } }
}

function getAll(limit = global.LIMIT, page = global.PAGE, filters = undefined) {
  return dispatch => {
    dispatch(request());

    permissionService.getAll(limit, page, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: permissionConstants.GET_PERMISSIONS_REQUEST } }
  function success(data) { return { type: permissionConstants.GET_PERMISSIONS_SUCCESS, data } }
  function failure(error) { return { type: permissionConstants.GET_PERMISSIONS_FAILURE, error } }
}

function add(permissionValues) {
  return dispatch => {
    dispatch(request(permissionValues));

    permissionService.add(permissionValues)
      .then(
        data => {
          dispatch(success())
          dispatch(alertActions.success(data.message));
        })
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: permissionConstants.ADD_PERMISSION_REQUEST } }
  function success() { return { type: permissionConstants.ADD_PERMISSION_SUCCESS } }
  function failure(error) { return { type: permissionConstants.ADD_PERMISSION_FAILURE, error } }
}

function update(permission_id, updatedValues) {
  return dispatch => {
    dispatch(request(updatedValues));

    permissionService.update(permission_id, updatedValues)
      .then(
        data => {
          dispatch(success());
          dispatch(alertActions.success(data.message));
          history.push(gisRoutes.administration.permission.list);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: permissionConstants.UPDATE_PERMISSION_REQUEST } }
  function success() { return { type: permissionConstants.UPDATE_PERMISSION_SUCCESS } }
  function failure(error) { return { type: permissionConstants.UPDATE_PERMISSION_FAILURE, error } }
}

function remove(permission_id) {
  return dispatch => {
    dispatch(request());

    permissionService.remove(permission_id)
      .then(
        data => {
          dispatch(success(data.permission));
          dispatch(alertActions.success(data.message));
          setTimeout(function () { window.location.reload() }, 2000);
        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error.data || error.message));
        });
  };

  function request() { return { type: permissionConstants.DELETE_PERMISSION_REQUEST } }
  function success() { return { type: permissionConstants.DELETE_PERMISSION_SUCCESS } }
  function failure(error) { return { type: permissionConstants.DELETE_PERMISSION_FAILURE, error } }
}
